// extracted by mini-css-extract-plugin
export default {"button":"XCN92YQDT0rnWkIQ4jBd","notified":"FcvZe2pTGsKqgBzPN3js"};